<template>
  <div>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
    <a href="https://api.whatsapp.com/send?phone=523311535434&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n." class="float" target="_blank">
        <i class="fa fa-whatsapp my-float"></i>
    </a>
     
     <!--<img height="1" width="1" src="https://www.facebook.com/tr?id=334366682205740&ev=PageView&noscript=1"/>-->

    <!-- Google Tag Manager (noscript) -->
  <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WQXH4VC"
            height="0" width="0" style="display:none;visibility:hidden">
    </iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->
    <!-- Header Top Area -->
    <div class="header_top_area hta_2">
        <div class="container">
            <div class="header_top_inner row m-0">
                <ul class="top_menu col-lg-3 col-md-4 p-0">
                    <li>
                      <a href="tel:3310782828" class="number" style="font-size: larger;">
                          <small>Llámanos</small>33 1078 2828
                        </a>
                    </li>
                </ul>
                <div class="top_menu col-lg-1 col-md-4 pr-0 pl-0 pb-0" style="padding-top: 13px">
                  <small class="number pl-2" style="font-size: larger;color: white; text-transform: uppercase; margin: 0px;">Soporte</small>
                </div>
                <div class="col-lg-4 text-center hidden-md">
                    <a href="/" class="navbar-brand"><img src="images/logo-splash.png" style="width: 220px" alt="Logo GPI Seguros"></a>
                </div>
                <div class="right_menu col-lg-3 col-md-4 p-0">
                    <ul class="right_nav">
                      <!-- <li><a href="#"><i class="fa fa-linkedin"></i></a></li> -->
                      <li><a href="https://www.facebook.com/credimoviI" target="_blank"></i></a></li>
                      <!-- <li><a href="#"><i class="fa fa-google-plus"></i></a></li> -->
                    </ul>
                </div>
            </div>
        </div>
        
    </div>
    <!-- Header Top Area -->
  </div>
</template>

<!-- Meta Pixel Code -->
<script>
  !function(f,b,e,v,n,t,s)
  {
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }
  (window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '738419298003478');
  fbq('track', 'PageView');
</script>

<noscript>
  <img height="1" width="1" style="display:none"
  src="https://www.facebook.com/tr?id=738419298003478&ev=PageView&noscript=1"/>
</noscript>
<!-- End Meta Pixel Code -->

<script>
  export default {
    name: 'Header'
  }
</script>

  
  <!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-TRC8XEPSVD"></script>
  <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-TRC8XEPSVD');
  </script>
</script>

<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-229991046-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-229991046-1');
</script>
<!-- Google Tag Manager -->
<script>
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WQXH4VC');
</script>
<!-- End Google Tag Manager -->

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/Header.vue